import { Injectable } from '@angular/core';
import { TimeoutError} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class ErrorHandler {
  constructor() {}

  public static parseError(error: Error){

    if(error instanceof TimeoutError){
        error['errorMessage'] = "Time out error. Please try again later"
        return error;
    }

    if(error instanceof HttpErrorResponse){
        if(error.status ===500 || error.status ===502){
            error['errorMessage'] = "Something went wrong. Please try again later";
            return error;
        }
    }

    if(error && error['status'] === -100){
        error['errorMessage'] = "Something went wrong. Please try again later";
        return error;
    }

  }
}
